const actions = {
    FETCH_USERS : 'FETCH_USERS',
    FETCH_USER_SUBSCRIPTIONS : 'FETCH_USER_SUBSCRIPTIONS',
    FETCH_USER  : 'FETCH_USER',
    RESET_USER  : 'RESET_USER',
    FETCH_USER_PROFILE_INFORMATION  : 'FETCH_USER_PROFILE_INFORMATION',

    fetchUsersAction: (data) => {
        return {
            type: actions.FETCH_USERS,
            data: data
        };
    },
    resetUserFormAction: () => {
        return {
            type: actions.RESET_USER,
            data: null
        };
    },
    fetchUserAction: (data) => {
        return {
            type: actions.FETCH_USER,
            data: data
        };
    },
    fetchUserProfileInformationAction: (data) => {
        return {
            type: actions.FETCH_USER_PROFILE_INFORMATION,
            data: data
        };
    },
    fetchUserSubscriptionsAction: (data) => {
        return {
            type: actions.FETCH_USER_SUBSCRIPTIONS,
            data: data
        };
    },
}

export default actions;
